<template>
  <div class="row">
    <div class="col-lg-12">
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing chat-card"
      >
        <div
          class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
        >
          <div class="d-flex align-items-center">
            <img
              :src="require('@/assets/images/NoImage.png')"
              width="44"
              height="44"
              class="rounded-circle"
              alt="user"
            />
            <div class="ms-15">
              <span class="d-block text-black fs-md-15 fs-lg-16 fw-medium"
                >Aylex</span
              >
            </div>
          </div>
          <div class="dropdown">
            <button
              class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="flaticon-dots"></i>
            </button>
          </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
          <div class="chat-list">
            <template v-for="(item, index) in messages" :key="index">
              <!-- Message from other user -->
              <div v-if="item.from != 1" class="chat-item position-relative">
                <img
                  :src="user?.logo"
                  width="44"
                  height="44"
                  class="rounded-circle user"
                  alt="user"
                />
                <span
                  class="d-block text-black fs-md-15 fs-lg-16 fw-medium mb-10"
                >
                  {{ user?.name }}
                  <span class="fs-12 text-muted fw-normal ms-5">{{
                    item.time
                  }}</span>
                </span>
                <div class="message position-relative">
                  <div class="inner">
                    <p class="fs-md-15 fs-lg-16 lh-base">
                      {{ item.message }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Message from current user -->
              <div v-else class="chat-item position-relative right">
                <span class="fs-12 text-muted fw-normal d-block mb-10">{{
                  item.time
                }}</span>
                <div class="message position-relative">
                  <div class="inner">
                    <p class="fs-md-15 fs-lg-16 lh-base">
                      {{ item.message }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="write-your-message position-relative" style="padding-right: 100px !important">
            <div class="write-message position-relative">
              <input
                type="text"
                v-model="chatInputMessage"
                class="input-message d-block w-100 text-black fs-14"
                placeholder="Saisir vote message"
              />
              <button
                type="button"
                class="bg-transparent p-0 border-0 transition"
              >
                <i class="ph ph-smiley"></i>
              </button>
            </div>
            <div class="buttons-list">
              <!-- <button
                type="button"
                class="border-0 d-inline-block position-relative text-center transition"
              >
                <i class="flaticon-gallery-1"></i>
              </button>
              <button
                type="button"
                class="border-0 d-inline-block position-relative text-center transition"
              >
                <i class="flaticon-link-1"></i>
              </button> -->
              <button
                type="button"
                @click="sendMessage()"
                class="border-0 d-inline-block position-relative text-center transition active"
              >
                <i class="flaticon-airplane"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { ref } from "vue";

export default {
  name: "ChatClaim",
  props: {
    messages: {
      type: Array,
      required: true,
    },
    fetchMessages: {
      type: Function,
      required: true,
    },
    rowClaim: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const auth = useAuthStore();
    const user = auth.user;
    // You can use props.messages here
    console.log(props.messages);
    const chatInputMessage = ref("");
    // Expose props/messages if you want to use them in the template

    async function sendMessage() {
      console.log(chatInputMessage.value);
      const data = new FormData();
      data.append("message", chatInputMessage.value); // if using ref
      data.append("claim_id", props.rowClaim.id);

      const res = await api.post(`/api/auth/client/sendMessage`, data);

      if (res.data.msg === "success") {
        // Call the parent fetch function passed as prop
        props.fetchMessages(props.rowClaim.id);
      }

      chatInputMessage.value = "";
    }

    return {
      claim: props.rowClaim,
      sendMessage,
      chatInputMessage,
      user,
    };
  },
};
</script>